import * as React from 'react';
import { fetchApi } from '../../services/api';
import { formatNumber } from '@progress/kendo-intl';
import { Button } from '@progress/kendo-react-buttons';

type State = {
  loading: boolean;
  conversionPercentage: any[];
  error?: string;
}

type Props = {
  filter: { Name: string, Filter: string };
}

export type ConversionPercentageResponse = Array<{ TimePeriod: string; ConversionPercentage: number; }>;

export default class ConversionPercentage extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      conversionPercentage: [],
    }

    this.refreshData = this.refreshData.bind(this);
  }

  public componentDidMount() {
    this.refreshData();
  }

  public refreshData() {
    fetchApi(`/api/Report/ConversionPercentage/${this.props.filter.Filter}`)
      .then((response: ConversionPercentageResponse) => {
        this.setState({
          loading: false,
          conversionPercentage: response,
          error: undefined,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error?.detail || 'Failed to load data'
        });
      });
  }

  public render() {
    if (this.state.loading) {
      return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card"></div>;
    }

    if (this.state.error) {
      return (
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card text-center p-3">
          <p style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.error}</p>
          <Button onClick={this.refreshData} fillMode='flat'>
            Retry
          </Button>
        </div>
      );
    }

    return <React.Fragment>
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card">
          <p>
            <span className="report-card-title">Secure Rate - {this.props.filter.Name}</span><br />
            <span className="text-muted small">Excludes ACTBE2 &amp; FC</span>
          </p>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Time Period</th>
                <th style={{ textAlign: 'right' }}>%</th>
              </tr>
            </thead>
            <tbody>
              {this.state.conversionPercentage.map((conversionPercentage, index) => {
                return <tr key={index}>
                  <td>{conversionPercentage.TimePeriod}</td>
                  <td style={{ textAlign: 'right' }}>{formatNumber(conversionPercentage.ConversionPercentage, "p")}</td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </React.Fragment>
  }
}
